import React, { useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

// Este componente recibe las opciones, nombre, reglas y cualquier error como props
function GenderSelect({
  control,
  name,
  rules,
  options,
  defaultValue,
  error,
  placeHolder,
  styles = {},
  controlHeight = 20,
  formLabel = '',
  classNames = {},
  classNamePrefix = 'classNamePrefix',
  handleOnChange,
  handleOnMenuOpen = () => {},
  handleOnMenuClose = () => {},
  disabled = false,
}) {
  const { i18n } = useTranslation();
  const selectRef = useRef(null);
  // Usamos useController para manejar el estado y validación del campo
  const {
    // Nos da el campo para conectar con react-select
    field,
    fieldState: { error: fieldError },
  } = useController({
    name,
    control,
    rules,
    defaultValue, // Las reglas de validación
  });

  useEffect(() => {
    selectRef.current.setValue(defaultValue);
  }, [defaultValue, selectRef]);

  const customTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      // primary25: 'lightgreen',  // Color cuando una opción está seleccionada
      // primary: 'darkgreen',     // Color principal (el borde del input, por ejemplo)
      // neutral0: 'whitesmoke',   // Fondo del dropdown
      // neutral5: 'gray',         // Borde del input
    },
    spacing: {
      ...theme.spacing,
      controlHeight, // Altura del campo de selección
      baseUnit: 2, // Espaciado base
    },
    borderRadius: 0, // Redondear bordes
  });

  const getOptionBackground = (isSelected, isFocused) => {
    if (isSelected) return '#F3FBFD';
    if (isFocused) return '#FAF8F4';
    return 'white';
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      ...styles,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0)',
      transition: 'transform 0.2s ease, color 0.2s ease',
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      backgroundColor: getOptionBackground(isSelected, isFocused),
      color: '#02090B',
      cursor: 'pointer',
    }),
  };

  const onSelectChange = (selectedOption) => {
    field.onChange(selectedOption); // Actualiza el valor en react-hook-form
    if (handleOnChange) handleOnChange(selectedOption); // Llama a la función adicional (si existe)
  };

  const showOptionLabel = (e) => e[`Name${i18n.language.toUpperCase()}`];

  return (
    <div className="custom-selct position-relative">
      <Card className={`${classNames.card} ${fieldError ? 'invalid-input-border' : ''}`}>
        <Card.Body className={`${classNames.cardBody}`}>
          <label
            htmlFor={`id-selector-${name}`}
            className={`mb-0 ${classNames.label}`}
          >
            {formLabel}
          </label>
          <Select
            isDisabled={disabled}
            ref={selectRef}
            // name={name}
            selectOption={defaultValue}
            value={options.find((option) => option.Code === defaultValue?.Code) || null}
            options={options}
            getOptionLabel={showOptionLabel} // Muestra el nameES en la lista
            getOptionValue={(e) => e.Code} // Define un valor único (opcional)
            placeholder={placeHolder}
            onChange={onSelectChange}
            onMenuOpen={() => handleOnMenuOpen()}
            onMenuClose={() => handleOnMenuClose()}
            className="react-select-container"
            classNamePrefix={classNamePrefix}
            noOptionsMessage={() => placeHolder}
            theme={customTheme} // Aplicamos el tema personalizado
            classNames={{
              control: (state) => (state.isFocused ? 'rounded-2 shadow-none' : 'rounded-2'),
            }}
            styles={customStyles}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default GenderSelect;
